module.exports = __webpack_public_path__ + "media/audios/kid/lesson_11/audio_tpc11-24d9fc6617517b94e0a56e0ae2241ad0.m4a";